import {Formik} from 'formik'
import {Button, Form, FormikSwitch, Lightbox, Spacer, Typography} from 'nf-ui'
import SvgClose from 'nf-ui/Icons/Close'
import React, {useState} from 'react'
import styled from 'styled-components'
import {useOrganisationIdStr} from '~/components/useOrganisationIdStr'
import {useMutationUpdateWeeklyEmailSettings, useQueryWeeklyEmailSettings} from '~/apollo/queries/WeeklyEmailSettings'
import {WeeklyEmailRecipientMode} from '~/globalTypes'

const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

type WeeklyEmailLightboxProps = {
    open: boolean
    onClose: () => void
}

export const WeeklyEmailLightbox: React.FC<WeeklyEmailLightboxProps> = ({open, onClose: onCloseProp}) => {
    const organisationIdStr = useOrganisationIdStr()
    const [changed, setChanged] = useState(false)
    const onLightboxClose = () => {
        setChanged(false)
        onCloseProp()
    }

    const [weeklyEmailSettings] = useQueryWeeklyEmailSettings(organisationIdStr)

    const [[, updateWeeklyEmailSettingsStatus], callUpdateWeeklyEmailSettings] = useMutationUpdateWeeklyEmailSettings()

    return (
        <Lightbox open={open} onClose={onLightboxClose} width={560}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <Typography.Heading>Weekly email</Typography.Heading>
                <Button variant="tertiary" disabled={updateWeeklyEmailSettingsStatus.loading} onClick={onLightboxClose}>
                    Close <Button.Icon icon={SvgClose} />
                </Button>
            </div>
            <Spacer height={16} />
            <Formik
                onSubmit={async ({weeklyStatsOn, sendToAll}) => {
                    await callUpdateWeeklyEmailSettings(
                        organisationIdStr,
                        weeklyStatsOn && sendToAll
                            ? WeeklyEmailRecipientMode.AUTHORISED
                            : WeeklyEmailRecipientMode.ACTIVE,
                        weeklyStatsOn,
                    )
                    onLightboxClose()
                }}
                initialValues={{
                    weeklyStatsOn: !!weeklyEmailSettings.data?.organisation.weeklyEmailSettings?.featureEnabled,
                    sendToAll:
                        weeklyEmailSettings.data?.organisation.weeklyEmailSettings?.recipientMode ===
                        WeeklyEmailRecipientMode.AUTHORISED,
                }}
            >
                {({handleSubmit, isSubmitting, values}) => {
                    return (
                        <Form style={{width: 'unset'}} onSubmit={handleSubmit}>
                            <Form.Group name="weeklyStatsOn">
                                <Form.Label>
                                    <FlexWrapper>
                                        <FormikSwitch onClick={() => setChanged(true)} />
                                        <Spacer width={16} />
                                        Send directory statistics each Monday by email to users that have been invited
                                        or are active
                                    </FlexWrapper>
                                </Form.Label>
                            </Form.Group>
                            {values.weeklyStatsOn ? (
                                <Form.Group name="sendToAll">
                                    <Form.Label>
                                        <FlexWrapper>
                                            <FormikSwitch onClick={() => setChanged(true)} />
                                            <Spacer width={16} />
                                            Also send to users that have not been invited yet
                                        </FlexWrapper>
                                    </Form.Label>
                                </Form.Group>
                            ) : null}
                            <Button type="submit" disabled={!changed} loading={isSubmitting}>
                                Save
                            </Button>
                        </Form>
                    )
                }}
            </Formik>
        </Lightbox>
    )
}
